import PropTypes from 'prop-types';
import { GENERIC_TABLE_DESIGN } from './GenericTable.design';

export default function GenericTable({ headLabels, children }) {
    return (
        <div className={GENERIC_TABLE_DESIGN.container}>
            <div className={GENERIC_TABLE_DESIGN.wrapper}>
                <div className={GENERIC_TABLE_DESIGN.innerWrapper}>
                    <div className={GENERIC_TABLE_DESIGN.header.container}>
                        {headLabels.map((head) => (
                            <div key={head.id} className={head.className || ''}>
                                {head.label}
                            </div>
                        ))}
                    </div>

                    {children}
                </div>
            </div>
        </div>
    );
}

GenericTable.propTypes = {
    headLabels: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            label: PropTypes.string,
            className: PropTypes.string,
        })
    ).isRequired,
    children: PropTypes.node,
};
